import { render, staticRenderFns } from "./RelatedProduct.vue?vue&type=template&id=fc89739c&"
import script from "./RelatedProduct.vue?vue&type=script&lang=js&"
export * from "./RelatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports